import { useSelector } from 'react-redux';
import * as Styled from '../../styles/UsuariosAprovados.styles';
import PropTypes from 'prop-types';
import ImageElement from '../../../../components/ImageElement/ImageElement';
import formatCPF from '../../../../utils/functions/formatCPF';
import formatCNPJ from '../../../../utils/functions/formatCNPJ';
import formatMoney from '../../../../utils/functions/formatMoneyBRL';

export default function InformationCollum() {
  const { usersData, usersBalance } = useSelector((state) => state.user);
  const conta = usersData.CONTA_BANCARIA_HUBFINTECH;
  const selfie = usersData?.DOCUMENTOS?.filter(
    (selfie) => selfie.CATEGORIA === '5',
  );

  return (
    <Styled.ProfileContainer>
      <ImageElement image={selfie && selfie[0].CAMINHO_ARQUIVO} />
      {conta?.length > 0 && (
        <Styled.AccountContainer>
          <div>
            Agência <b>{conta[conta.length - 1].AGENCIA}</b>
            {conta[conta.length - 1].DIGITO_AGENCIA &&
              -conta[conta.length - 1].DIGITO_AGENCIA}
          </div>
          <div>
            Conta
            <b>
              {conta[conta.length - 1].CONTA} -{conta[conta.length - 1].DIGITO}
            </b>
          </div>
        </Styled.AccountContainer>
      )}
      <h4>Saldo Atual</h4>
      <h3>R$ {formatMoney(usersBalance.SALDO_ATUAL)}</h3>
      <h4>CPF/CNPJ</h4>
      <h5>
        {usersData.CPFCNPJ?.length === 11
          ? formatCPF(usersData.CPFCNPJ)
          : formatCNPJ(usersData.CPFCNPJ)}
      </h5>
    </Styled.ProfileContainer>
  );
}

InformationCollum.propTypes = {
  control: PropTypes.any,
  isEditing: PropTypes.bool,
};
